import React, { createContext, useContext } from "react"
import { IPdfStrings } from "@services/pdf/generator"
import { TPdfLayoutType } from "@services/pdf/types"
import { IBuilderAssets } from "./hooks/useBuilderAssets"
import { IBuilderState, TBuilderAction } from "./state/reducer"

export interface IBuilderContext {
	state: IBuilderState
	dispatch: React.Dispatch<TBuilderAction>
	assets: IBuilderAssets
	strings: IPdfStrings
	layoutType: TPdfLayoutType
	documentTitle: string
	onClose: () => void
	onExported: () => void
}

const builderContext = createContext<IBuilderContext | null>(null)

export const BuilderProvider = builderContext.Provider

export function useBuilder(): IBuilderContext {
	const context = useContext(builderContext)
	if (!context) {
		throw new Error("useBuilder must be used within BuilderProvider")
	}
	return context
}
